import React from 'react'
import { withRouter } from 'react-router-dom'

// Components
import Modal from '../../UIkit/Modal'


class ModalQuizTimeRanOut extends React.Component {
  render() {
    return (
      <Modal
        id={this.props.id}
        body={
          <div>
            <div className="uk-padding-small uk-text-center">
              <h3>Whoops! You ran out of time...</h3>
              <p>The next question will start once you click the button below.</p>
              <div className="uk-padding">
                <button
                  className="uk-button uk-button-primary tm-button-primary uk-align-right"
                  onClick={this.props.onStartNextQuestion}
                >
                  Start Next Question
                </button>
              </div>
            </div>
          </div>
        }
      />
    )
  }
}

export default withRouter(ModalQuizTimeRanOut)
